// extracted by mini-css-extract-plugin
module.exports = {"numberBox":"numberInput_numberBox__1EndD","input":"numberInput_input__MRQHO"};